import {MultimediaMessageContent} from '@/types/matrix';
import {
  EventType,
  ISendEventResponse,
  MatrixClient,
  MatrixEvent,
  RelationType
} from 'matrix-js-sdk';
import {RoomMessageEventContent} from 'matrix-js-sdk/lib/types';

export const deleteImage = async (
  matrixClient: MatrixClient,
  currentMatrixRoomId: string,
  parentImageEvent: MatrixEvent,
  imageToDeleteUrl: string
): Promise<ISendEventResponse> => {
  const originalContent = parentImageEvent.getEffectiveEvent().content;
  const urlParts = imageToDeleteUrl.split('/');
  const urlToDeleteSuffix = urlParts.slice(-1)[0];

  let newMainUrl = originalContent.url;
  let newMainIndex = originalContent.index;
  let newAdditional = originalContent.additional || [];
  const newContentBody = originalContent.body;

  if (originalContent.url.includes(urlToDeleteSuffix)) {
    if (newAdditional.length > 0) {
      const [newMainImage, ...restAdditional] = newAdditional;
      newMainUrl = newMainImage.url;
      newMainIndex = newMainImage.info.index;
      newAdditional = restAdditional;
    } else {
      newMainUrl = '';
    }
  } else {
    newAdditional = newAdditional.filter(
      (image: MultimediaMessageContent) =>
        !image.url.includes(urlToDeleteSuffix)
    );
  }

  if (newMainUrl === '' && newAdditional.length === 0) {
    const deletionReason = `User deleted message`;
    const redatctedResponse = await matrixClient.redactEvent(
      currentMatrixRoomId,
      parentImageEvent.getEffectiveEvent().event_id,
      undefined,
      {
        reason: deletionReason
      }
    );
    return redatctedResponse;
  }

  const newEventContent = {
    body: newContentBody,
    msgtype: 'm.image',
    url: newMainUrl,
    info: {
      ...originalContent.info,
      index: newMainIndex
    },
    additional: newAdditional,
    'm.new_content': {
      body: newContentBody,
      msgtype: 'm.image',
      url: newMainUrl,
      info: originalContent.info,
      additional: newAdditional
    }
  };
  const newEvent = await matrixClient.sendEvent(
    currentMatrixRoomId,
    EventType.RoomMessage,
    {
      'm.relates_to': {
        rel_type: RelationType.Replace,
        event_id: parentImageEvent.getEffectiveEvent().event_id
      },
      ...newEventContent
    } as RoomMessageEventContent
  );
  return newEvent;
};
